import axios from 'axios'
import { Api, Config } from './api'

export const ApiObterReferencias = async (filtros) => {
  const params = new URLSearchParams()

  if (filtros.limite) {
    params.append('limite', filtros.limite)
  }

  if (filtros.pagina != null && filtros.pagina != undefined) {
    params.append('pagina', filtros.pagina)
  }
  if (filtros.DataInicio) {
    params.append('DataInicio', filtros.DataInicio)
  }

  if (filtros.DataFim) {
    params.append('DataFim', filtros.DataFim)
  }
  if (filtros.Mes) {
    params.append('Mes', filtros.Mes)
  }
  if (filtros.Ano) {
    params.append('Ano', filtros.Ano)
  }

  const { data } = await Api.get(`/referencia`, Config(params))

  return data
}

export const ApiObterReferenciasPeriodo = async (filtros) => {
  const params = new URLSearchParams()

  if (filtros.limite) {
    params.append('limite', filtros.limite)
  }

  if (filtros.pagina != null && filtros.pagina != undefined) {
    params.append('pagina', filtros.pagina)
  }

  const { data } = await Api.get(`/referencia/periodo`, Config(params))

  return data
}

export const ApiObterReferenciaBloqueio = async (id) => {
  const { data } = await Api.get(`/referencia-bloqueio/${id}`, Config())

  return data
}

export const ApiObterReferenciaSubPeriodos = async (id) => {
  const { data } = await Api.get(`/referencia-bloqueio/${id}/subperiodos`, Config())

  return data
}

export const ApiRegistrarReferenciaBloqueio = async (payload) => {
  const { data } = await Api.put(`/referencia-bloqueio/${payload.id}`, payload.body, Config())

  return data
}
